/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Day_SatInputs */

const en_ui_day_sat = /** @type {(inputs: Ui_Day_SatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sat`)
};

const de_ui_day_sat = /** @type {(inputs: Ui_Day_SatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sa`)
};

/**
* | output |
* | --- |
* | "Sat" |
*
* @param {Ui_Day_SatInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_day_sat = /** @type {((inputs?: Ui_Day_SatInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Day_SatInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_day_sat(inputs)
	return de_ui_day_sat(inputs)
});